import type { Story } from '@/store/story-types'

export const AGENCY_STUDIO_NEW3_STORY: Story = {
  id: 'agency-studio-new3',
  name: 'STUDIO — Creative Agency',
  narrative: 'A creative agency portfolio with dark theme, mesh gradient accents, service showcase, portfolio grid, process timeline, and contact form.',
  goals: ['Showcase creative services and capabilities', 'Display portfolio with project highlights', 'Present agency process and methodology', 'Enable client inquiries via contact form'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'home', description: 'Single-page portfolio with hero, services, portfolio grid, process timeline, and contact' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'View Services',
      description: 'Visitor views the agency services',
      steps: [
        { type: 'given', text: 'the visitor opens the agency website' },
        { type: 'when', text: 'they scroll to the services section' },
        { type: 'then', text: 'service cards with descriptions and icons are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'Browse Portfolio',
      description: 'Visitor browses portfolio projects',
      steps: [
        { type: 'given', text: 'the visitor is on the home page', linkedPageId: 'home' },
        { type: 'when', text: 'they scroll to the portfolio section' },
        { type: 'then', text: 'project cards with thumbnails and descriptions are visible' },
      ],
    },
    {
      id: 'bdd-3', name: 'Submit Inquiry',
      description: 'Visitor submits a contact inquiry',
      steps: [
        { type: 'given', text: 'the visitor scrolls to the contact section' },
        { type: 'when', text: 'they fill out and submit the contact form' },
        { type: 'then', text: 'a confirmation message is displayed', linkedFlowId: 'submitContact' },
      ],
    },
  ],
}
